/** Must match Expo bootsplash logoWidth and the generated native manifest. */
export const WELCOME_HANI_SPLASH_SIZE = 120;
export const WELCOME_HANI_SIZE = 96;
/** Last solid foot row in the bundled 120px splash portrait; ignore its transparent bottom pad. */
export const WELCOME_HANI_CONTACT = WELCOME_HANI_SIZE * (106 / 120);

/** Same 3D splash portrait: centre → below the screen → sheet edge → behind the sheet. */
export function welcomeHaniTop(
  progress: number,
  sheetTop: number,
  windowHeight: number,
  splashSize = WELCOME_HANI_SPLASH_SIZE,
): number {
  "worklet";
  const centre = (windowHeight - splashSize) / 2;
  const below = windowHeight + splashSize;
  const perched = sheetTop - WELCOME_HANI_CONTACT;
  if (progress <= 1) {
    return centre + (below - centre) * Math.max(0, progress);
  }
  if (progress <= 2) {
    return below + (perched - below) * (progress - 1);
  }
  return perched + (WELCOME_HANI_SIZE + 12) * Math.min(1, progress - 2);
}

/** Resize only at the fully offscreen turnaround; never crossfade the native portrait. */
export function welcomeHaniSize(progress: number, splashSize = WELCOME_HANI_SPLASH_SIZE): number {
  "worklet";
  return progress <= 1 ? splashSize : WELCOME_HANI_SIZE;
}

/** A cancelled celebration must not leak its tilt, scale or lift into another visit. */
export function resetWelcomeHaniMotion(
  progress: { set: (value: number) => void },
  delight: { set: (value: number) => void },
): void {
  progress.set(1);
  delight.set(0);
}

/** Descend only when a ready replica was armed under the native splash. */
export function welcomeHaniEntrance({
  armed,
  ready,
  revealed,
}: {
  armed: boolean;
  ready: boolean;
  revealed: boolean;
}): "wait" | "arm" | "descend" | "rise" {
  if (!ready) {
    return "wait";
  }
  if (!revealed) {
    return "arm";
  }
  return armed ? "descend" : "rise";
}
